var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "article-list__filter" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hideArticleCategories,
              expression: "!hideArticleCategories",
            },
          ],
          staticClass: "article-list__category",
          class: _vm.filterDropDownIsOpen
            ? "article-list__category--is-open"
            : "article-list__category--is-closed",
          on: {
            click: function ($event) {
              _vm.filterDropDownIsOpen = !_vm.filterDropDownIsOpen
            },
          },
        },
        [
          _c("div", { staticClass: "article-list__category-button" }, [
            _c("span", { staticClass: "article-list__category-label" }, [
              _vm._v(_vm._s(_vm.filterByText.toUpperCase())),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "article-list__category-current" }, [
              _vm._v(_vm._s(_vm.selectedCategory.name.toUpperCase())),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "article-list__category-arrow" }),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "article-list__category-choices" },
            _vm._l(_vm.allCategories, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: `article-list__category-button ${item.slug}`,
                  attrs: { name: item.slug },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.selectCategory(item)
                      _vm.applyFilter(item.term_id)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(item.name.toUpperCase()) +
                      "\n                "
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "article-list__posts-container" }, [
      _c(
        "div",
        { staticClass: "article-list__posts-display" },
        _vm._l(_vm.filteredPosts, function (post, index) {
          return _c("section", { key: index }, [
            _vm.thumbnailOverlay
              ? _c("div", {
                  staticClass: "article-list__posts-display-overlay",
                })
              : _vm._e(),
            _vm._v(" "),
            _c("picture", [
              _c("source", {
                attrs: { srcset: post.srcset, sizes: post.sizes },
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  loading: "lazy",
                  src: post.src,
                  width: post.width,
                  height: post.height,
                  sizes: post.sizes,
                  alt: post.alt,
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "article-list__posts-display-content" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "40px",
                    height: "2px",
                    viewBox: "0 0 40 2",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        stroke: "none",
                        "stroke-width": "2",
                        fill: "none",
                        "fill-rule": "evenodd",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            transform: "translate(-20.000000, -916.000000)",
                            fill: "#fff",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                transform: "translate(20.000000, 904.000000)",
                              },
                            },
                            [
                              _c("g", [
                                _c("rect", {
                                  attrs: {
                                    x: "0",
                                    y: "12",
                                    width: "40",
                                    height: "2",
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "h6" }, [
                _vm._v(_vm._s(_vm.formatDate(post.post_date))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "article-list__posts-display-content-title" },
                [_vm._v(_vm._s(post.title))]
              ),
            ]),
            _vm._v(" "),
            _c("a", { attrs: { "aria-label": "", href: post.link } }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "40",
                    height: "13.657",
                    viewBox: "0 0 40 13.657",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      id: "Combined_Shape_Copy",
                      "data-name": "Combined Shape Copy",
                      d: "M32.465,13.364a1,1,0,0,1,0-1.415l4.121-4.121H1a1,1,0,0,1,0-2H36.586L32.465,1.707A1,1,0,1,1,33.879.293L39.535,5.95a1.012,1.012,0,0,1,.08.09,1,1,0,0,1,0,1.577,1.007,1.007,0,0,1-.08.09l-5.657,5.657a1,1,0,0,1-1.414,0Z",
                      transform: "translate(0 0)",
                    },
                  }),
                ]
              ),
            ]),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.showButton
            ? `article-list__load-more`
            : `article-list__load-more hidden`,
        },
        [
          _c("button", { staticClass: "btn--quaternary" }, [
            _vm._v(_vm._s(_vm.loadMoreText)),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }